module.exports = __webpack_public_path__ + "static/media/fileUpload.992fec1b.svg";